import $ from 'jquery';
import {setElementsFromScope} from '../../utilities/selectorHelpers';
import _ from "underscore";

const elementsPageMap = {
  productItemLookup: "#product-item-lookup"
};

export default function ProductsTab(wizard){
  const self = this;
  const elsPage = {};
  const wizardElement = wizard.getWizardElement();
  var items = wizardElement.data("items");
  var productArryJSON = wizardElement.data("product-name-arr");
  const portletNamespace = wizardElement.data("portlet-namespace");

  self.init = function(){
    setElements();
    setWidgets();
    bindElements();
  };

  function setElements() {
    setElementsFromScope(elsPage, elementsPageMap, wizardElement);
  };

  function setWidgets() {
    instantiateSkuTypeAhead();
    const productItemLookup = elsPage.productItemLookup;
    productItemLookup.on("select2:select", function() {
        $(".no-products-added-error-msg").hide();
        var res = productItemLookup.select2('data')[0].text.split("--");
        addProducts(res[0],res[1],res[2],res[3]);
        productItemLookup.val(null).trigger('change');
    });
  }

  function bindElements(){
    $(document).on('click', '#product-tab-create-ord .icon-remove', removeProductRelatedRows);
  }

  function instantiateSkuTypeAhead(){

    const select2AjaxDefaults = {
      dataType: 'json',
      delay: 250,
      processResults: function (data, params) {
        params.page = params.page || 1;
        return {
          results: getProductNamesAndItems(data),
          pagination: {
            more: (params.page * 20) < data.total_count
          }
        };
      },
      cache: true
    };

    function configureDataCallback({paramKey}){
      return function(params){
        return {
          [paramKey] : params.term
        };
      };
    }

    elsPage.productItemLookup.select2({
      placeholder: "Type product name (SKU)",
      allowClear: true,
      ajax: {
        ...select2AjaxDefaults,
        url: wizardElement.data("get-product-names-and-items-url"),
        data: configureDataCallback(
          {
            paramKey: 'likeSku'
          }
        )
      },
      minimumInputLength: 3
    });

  }

  function getProductNamesAndItems(response) {
    items = response.items;
    return response.productNameArr;
  }

  var addProducts = function(productName,prodDescription,availUnit,prdType) {
	if($("#product-tab-create-ord tbody tr").length >= 10){
		$('#maxProductErrorModal').modal("show");
		return;
	}
    var highestId = parseInt($("#product-tab-create-ord tbody tr:last").attr("id"));
    if(isNaN(highestId)){
      highestId = 0;
    }else{
      ++highestId;
    }

    const productRow = $('<tr id=' + highestId + ' class="product-item">')
      .append($('<td class="vert-middle">')
        .append($('<input type="number">')
          .attr('id', portletNamespace + 'quantity'+highestId)
          .attr('name', 'quantity'+'_row_'+highestId)
          .attr('min', '1')
          .attr('class', `form-control required ${portletNamespace}quantity q-input text-center products-tab-quantity-input jqv-whole-number`)
          .attr('placeholder', "Quantity")
          .attr('value', "1")

          )
        .append($('<input type="hidden">')
          .attr('name', 'prodTabSku')
          .attr('value', productName+"_row_"+highestId)
          )
        )
      .append($('<td class="vert-middle">')
        .append($('<span class="text-purple products-tab-product-name">')
          .attr('id', productName+'_row_'+highestId)
          .text(productName)
          )
        .append($('<input type="hidden">')
          .attr('name', 'prodTabProductName'+'_row_'+highestId)
          .attr('value', productName)
          )
        //.append(determineBundleIcon(prdType))
        )
      .append($('<td class="vert-middle">')
        .append($('<span class="products-tab-product-description">')
          .attr('name', portletNamespace + 'prodDescription')
          .attr('id', portletNamespace + 'prodDescription')
          .text(prodDescription)
          )
        .append($('<input type="hidden">')
          .attr('name', 'prodTabProdDescription'+'_row_'+highestId)
          .attr('value', prodDescription)
          )
        )
      .append($('<td class="text-center vert-middle">')
        .append($('<span>')
          .attr('id', 'delete_row'+highestId)
          .attr('class', 'icon-remove')
          .attr('style', 'cursor: pointer;')
            // .attr('onclick', 'removeRow('+ 'delete_row' + highestId +')')
            )
        );

    $("#product-tab-create-ord").find('tbody').append(productRow);

    if(prdType === "Bundle") {
      //append child products
      _.each(items, function(item) {
        let childRows = [];
        if(item.itmSku === productName) {
          const kitItems = item.kitItems;
          let idVal = 0;
          _.each(kitItems, function(kitItem) {
              idVal++;
              const childRow =  $('<tr id=' + idVal + ' class="product-item-child">')
                .append($('<td class="vert-middle">')
                )
                .append($('<td class="vert-middle">')
                  .append($('<i class="fa fa-level-down q-icon-marg-right q-icon-marg-left" aria-hidden="true"></i>'))
                  .append($('<span class="text-purple products-tab-child-product-name">')
                  .attr('id', kitItem.kitChildItmSku+'_row_'+idVal)
                  .text(kitItem.kitChildItmSku)
                  )
                )
                .append($('<td class="vert-middle">')
                  .append($('<span class="products-tab-child-product-description">')
                  .attr('name', portletNamespace + 'prodDescription')
                  .attr('id', portletNamespace + 'prodDescription')
                  .text(kitItem.prdName)
                  )
                )
                .append($('<td class="vert-middle">')
                );

                productRow.after(childRow);
                childRows.push(childRow);
          });

          productRow.data("childProducts", childRows);

        }
      });
    }
  }

  self.loadProductsOnLoad = function() {
	$(items).each(function() {
		loadProducts(this.itmSku, this.prdNameAndAttributes);
	});
  }

  var loadProducts = function(productName,prodDescription) {
    var highestId = parseInt($("#listOfProducts tbody tr:last").attr("id"));
    if(isNaN(highestId)){
      highestId = 0;
    }else{
      ++highestId;
    }
    const productRow = $('<tr id=' + highestId + ' class="">')
      .append($('<td class="">')
	    .append($('<div class="checkbox checkbox-success cb-large">')
          .append($('<input type="checkbox">')
			.attr('id', 'prodTabSku'+"_row_"+highestId)
			.attr('name', 'prodSkuFromModal')
			.attr('value', productName)
            )
		    .append($('<label for="prodTabSku_row_'+highestId+'">')
            )
		  )
        )
      .append($('<td class="">')
        .append($('<span class="products-tab-product-name">')
          .attr('id', productName+'_row_'+highestId)
          .text(productName)
          )
        .append($('<input type="hidden">')
          .attr('name', 'prodTabProductName'+'_row_'+highestId)
          .attr('value', productName)
          )
        )
      .append($('<td class="">')
        .append($('<span class="products-tab-product-description">')
          .attr('name', portletNamespace + 'prodDescription')
          .attr('id', portletNamespace + 'prodDescription')
          .text(prodDescription)
          )
        .append($('<input type="hidden">')
          .attr('name', 'prodTabProdDescription'+'_row_'+highestId)
          .attr('value', prodDescription)
          )
        );
    $("#listOfProducts").find('tbody').append(productRow);

  }

  $('#addProductsLink').click(function() {
    $('#listOfProductsModal div input').prop('checked', false);
  });

  function removeProductRelatedRows(e) {
	const el = $(e.target);
    const coreProduct = el.closest('tr');
    const childProducts = coreProduct.data("childProducts");
    if(childProducts && childProducts.length) {
      _(childProducts).map(function(childProduct) {
        childProduct.remove();
      })
    }
    coreProduct.remove();
  }

  $('#search-product-name').on('keyup', function (){
	var keyword = this.value;
	$("#listOfProducts > tbody").html("");
	$(items).each(function(){
		if(this.itmSku.toLowerCase().indexOf(keyword.toLowerCase()) >= 0){
		  loadProducts(this.itmSku, this.prdNameAndAttributes);
		}else if(this.prdNameAndAttributes.toLowerCase().indexOf(keyword.toLowerCase()) >= 0){
		  loadProducts(this.itmSku, this.prdNameAndAttributes);
		}
	});
  });

  $('#add-product-from-modal').on('click', function (){
    $(".no-products-added-error-msg").hide();
	 var boxes = $('input[name=prodSkuFromModal]:checked');
	 boxes.each(function(){
		const sku = this.value;
		$(items).each(function(){
			if(this.itmSku === sku){
			  addProducts(this.itmSku, this.prdNameAndAttributes, 0, this.type);
			}
		});
	 });
	 $('#listOfProductsModal').modal('toggle');
  });

}



// WEBPACK FOOTER //
// ./src/pages/order/addProductsAmazon.js